import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { COBALT_FLAG_MESSAGE_DEFAULT_CONFIG } from '@cae/cobalt-angular/components/flag-message';
import {
  COBALT_DATE_FORMATS,
  CobaltDateAdapterService
} from '@cae/cobalt-angular/core';
import { CorePilotModule } from '@core/core-pilot.module';
import { ServerErrorInterceptor } from '@core/interceptors/server-error/server-error.interceptor';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { FeatureFlagService } from '@shared/components/feature-toggle/services/feature-flag.service';
import { FeatureFlagsInitService } from '@shared/components/feature-toggle/services/feature-flags-init.service';
import { LaunchDarklyService } from '@shared/components/feature-toggle/services/launch-darkly.service';
import {
  swiperOptions,
  swiperOptionsList
} from '@shared/models/constants/swiper.token';
import { CarouselService } from '@shared/services/carousel/carousel.service';
import { AuthB2CService, LogService, StorageService } from 'common-web-core';
import { CookieService } from 'ngx-cookie-service';

import { initializeAppDependencies } from './app.initializers';
import { APP_ROUTES } from './app.routes';
import { StoreModule } from './store/store.module';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(APP_ROUTES),
    importProvidersFrom(CorePilotModule, StoreModule),
    AppSettingsService,
    AuthB2CService,
    CarouselService,
    CobaltDateAdapterService,
    CookieService,
    FeatureFlagService,
    FeatureFlagsInitService,
    LaunchDarklyService,
    LogService,
    StorageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppDependencies,
      deps: [
        AppSettingsService,
        AuthB2CService,
        LogService,
        FeatureFlagsInitService,
        LaunchDarklyService,
        FeatureFlagService,
        StorageService,
        HttpClient
      ],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true
    },
    {
      provide: COBALT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'dd-MM-yyyy'
        },
        display: {
          dateA11yLabel: 'DDD',
          dateInput: 'dd-MM-yyyy',
          monthLabel: 'LLL',
          monthYearA11yLabel: 'LLLL yyyy',
          yearA11yLabel: 'yyyy',
          yearLabel: 'yyyy'
        }
      }
    },
    {
      provide: COBALT_FLAG_MESSAGE_DEFAULT_CONFIG,
      useValue: {
        duration: 4000,
        position: {
          top: 88,
          right: 24
        }
      }
    },
    { provide: 'SWIPER_OPTIONS', useValue: swiperOptions },
    { provide: 'SWIPER_OPTIONSLIST', useValue: swiperOptionsList }
  ]
};
